import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class PackagesService extends CentralService {
  protected resource: string = "packages";
}
